import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const NotificationSettingsState = Record({
    loading: false,
    updating: false,
    settings: List(),
});

export default handleActions(
    {
        [Actions.fetchNotificationSettings.type]: state => {
            return state.merge({
                loading: true,
            });
        },
        [Actions.fetchNotificationSettingsSuccess.type]: (state, {payload}) => {
            return state.merge({
                loading: false,
                settings: payload.notificationSettings,
            });
        },
        [Actions.fetchNotificationSettingsFailed.type]: state => {
            return state.merge({
                loading: false,
            });
        },
        [Actions.updateNotificationSettings.type]: state => {
            return state.merge({
                updating: true,
            });
        },
        [Actions.updateNotificationSettingsSuccess.type]: (state, {payload}) => {
            return state.merge({
                settings: payload.notificationSettings,
                updating: false,
            });
        },
        [Actions.updateNotificationSettingsFailed.type]: state => {
            return state.merge({
                updating: false,
            });
        },
    },
    new NotificationSettingsState(),
);
